import React from 'react';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import ChatBot from './components/ChatBot';

function App() {
  return (
    <div className="App">
      <Header />
      <HomePage />
      <ChatBot />
      <Footer />
    </div>
  );
}

export default App;
